import React from 'react';
import { CTAButton } from './CTAButton';
export const PerfectForSection = () => {
  return <section className="w-full bg-white py-16 px-4" data-id="element-465">
      <div className="max-w-5xl mx-auto" data-id="element-466">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-teal-600 mb-4" data-id="element-467">
          The Ardava Bamboo Knee Sleeve
        </h2>
        <h3 className="text-2xl md:text-3xl font-bold text-center text-teal-700 mb-10" data-id="element-468">
          Is Perfect For...
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-469">
          {/* First row */}
          <div className="flex flex-col items-center" data-id="element-470">
            <div className="mb-4 rounded-lg overflow-hidden" data-id="element-471">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sY4DfUUDzSBoAmobEuawPR/standingDoingChores.gif" alt="Woman doing household chores with knee support" className="w-full h-48 object-cover" data-id="element-472" />
            </div>
            <h4 className="font-bold text-xl mb-3 text-teal-700" data-id="element-473">
              Household Chores
            </h4>
            <p className="text-center text-gray-600" data-id="element-474">
              Maintain stability and comfort while doing everyday tasks around
              the house. The sleeve stays in place even when bending and moving
              frequently.
            </p>
          </div>
          <div className="flex flex-col items-center" data-id="element-475">
            <div className="mb-4 rounded-lg overflow-hidden" data-id="element-476">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iuyRi84PZYMifptWgLdM5P/Waiter_Standing.webp" alt="Server working a long shift" className="w-full h-48 object-cover" data-id="element-477" />
            </div>
            <h4 className="font-bold text-xl mb-3 text-teal-700" data-id="element-478">
              Long Work Shifts
            </h4>
            <p className="text-center text-gray-600" data-id="element-479">
              Breathable bamboo technology keeps your knee comfortable during
              12-hour shifts without slipping or bunching, even when you're
              constantly on your feet.
            </p>
          </div>
          <div className="flex flex-col items-center" data-id="element-480">
            <div className="mb-4 rounded-lg overflow-hidden" data-id="element-481">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fV9dADFkBhUkWmbxfG9a6E/Daily_Walks.webp" alt="Group of people walking together" className="w-full h-48 object-cover" data-id="element-482" />
            </div>
            <h4 className="font-bold text-xl mb-3 text-teal-700" data-id="element-483">
              Daily Walks
            </h4>
            <p className="text-center text-gray-600" data-id="element-484">
              Stay-put design means you can focus on enjoying your walk instead
              of constantly adjusting your knee sleeve. Perfect for maintaining
              an active lifestyle.
            </p>
          </div>
          {/* Second row */}
          <div className="flex flex-col items-center" data-id="element-485">
            <div className="mb-4 rounded-lg overflow-hidden" data-id="element-486">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dZbsif4f7wVSRXCMxQ867n/Climbing_Stairs.webp" alt="People climbing stairs together" className="w-full h-48 object-cover" data-id="element-487" />
            </div>
            <h4 className="font-bold text-xl mb-3 text-teal-700" data-id="element-488">
              Climbing Stairs
            </h4>
            <p className="text-center text-gray-600" data-id="element-489">
              The micro-grip technology prevents slipping when navigating
              stairs, giving you added confidence and stability without constant
              readjustment.
            </p>
          </div>
          <div className="flex flex-col items-center" data-id="element-490">
            <div className="mb-4 rounded-lg overflow-hidden" data-id="element-491">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/83TT4JM1iNV6EsRr8R7ZBa/Family_gathering.webp" alt="Family gathering at home" className="w-full h-48 object-cover" data-id="element-492" />
            </div>
            <h4 className="font-bold text-xl mb-3 text-teal-700" data-id="element-493">
              Family Gatherings
            </h4>
            <p className="text-center text-gray-600" data-id="element-494">
              Comfortable enough to wear all day during extended family events.
              The low-profile design fits discreetly under most clothing.
            </p>
          </div>
          <div className="flex flex-col items-center" data-id="element-495">
            <div className="mb-4 rounded-lg overflow-hidden" data-id="element-496">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rrQZvDYNuWq86YdzL7u8ah/Light_Exercise.webp" alt="Person doing exercises at home" className="w-full h-48 object-cover" data-id="element-497" />
            </div>
            <h4 className="font-bold text-xl mb-3 text-teal-700" data-id="element-498">
              Light Exercise
            </h4>
            <p className="text-center text-gray-600" data-id="element-499">
              Gentle compression provides support during yoga, light workouts,
              and stretching routines without restricting movement or causing
              discomfort.
            </p>
          </div>
        </div>
        <div className="text-center mb-10" data-id="element-500">
          <p className="text-gray-700 text-lg mb-6" data-id="element-501">
            Experience the difference of a knee sleeve that actually stays up
            all day, in any situation, without constant adjustments or
            discomfort.
          </p>
          <CTAButton text="Get Your Ardava Sleeve Today — 60-Day Guarantee" data-id="element-502" />
        </div>
      </div>
    </section>;
};